import { render, staticRenderFns } from "./fraction.vue?vue&type=template&id=9fffb71a&scoped=true"
import script from "./fraction.vue?vue&type=script&lang=js"
export * from "./fraction.vue?vue&type=script&lang=js"
import style0 from "./fraction.vue?vue&type=style&index=0&id=9fffb71a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fffb71a",
  null
  
)

export default component.exports